import point from './point.vue';
const properties = [point];
export default properties